import React from 'react'
import ConfirmDialog from '../ConfirmDialog/ConfirmDialog'

const ProcessPaymentConfirm = ({ open, onClose, amount, methodType, last4, confirmDisabled, onConfirm, children }) => {
  const method = methodType === 'Bank Account' ? 'Bank account' : 'Card'
  return (
    <ConfirmDialog
      open={open}
      onClose={onClose}
      title={`Charge ${amount} now?`}
      impact={[
        `${method}${last4 ? ` ending ${last4}` : ''} is charged ${amount} through the gateway chosen below.`,
        'The charge cannot be cancelled after you confirm.',
      ]}
      confirmLabel={`Charge ${amount}`}
      confirmDisabled={confirmDisabled}
      onConfirm={onConfirm}
    >
      {children}
    </ConfirmDialog>
  )
}

export default ProcessPaymentConfirm
